import { IKey } from '@/common/constants/ikey'
import { emptyUniDataTableField } from '@/common/utils/treeTableReloadNodePayload'
import { setType } from '@/common/utils/typedValueSerializer'

export const TREE_TABLE_GROW_UP_ROOT_KEY = '__treeTableShowRoot'

export function isTreeTableGrowUpRootNode(node: { key?: unknown; isGrowUpRoot?: unknown } | null | undefined): boolean {
  if (!node) return false
  if (node.isGrowUpRoot === true) return true
  return String(node.key ?? '') === TREE_TABLE_GROW_UP_ROOT_KEY
}

export function buildFindParentRootReloadPayload(
  elementName: string,
  expandParamFields: Record<string, { value: unknown; type: string }>,
  visibleRowNum: number,
): Record<string, unknown> {
  const name = String(elementName ?? '').trim()
  const paramsTable =
    Object.keys(expandParamFields).length === 0
      ? emptyUniDataTableField()
      : {
          type: 'UniDataTable',
          value: {
            rows: [{ fields: expandParamFields, errors: {}, attributes: {} }],
            columns: [] as unknown[],
            attributes: {},
            empty: false,
          },
        }
  return {
    [`${name}__${IKey.ROW_NUM}`]: setType(visibleRowNum),
    [`${name}${IKey.PARAMS}`]: paramsTable,
    [`${name}__${IKey.ACTION}`]: setType(IKey.TT_ACTION_FIND_PARENT_ROOT_ASINC),
    [`${name}${IKey.TT_INIT}`]: setType(false),
    [`${name}${IKey.TT_FORCE_LOAD_ALL}`]: setType(false),
  }
}

export function extractTreeTableParentRowsFromReload(
  tableField: unknown,
): unknown[] {
  if (!tableField || typeof tableField !== 'object') return []
  const rec = tableField as { value?: { rows?: unknown[] }; rows?: unknown[] }
  const rows = rec.value?.rows ?? rec.rows
  return Array.isArray(rows) ? rows : []
}

function cloneJson<T>(value: T): T {
  try {
    return JSON.parse(JSON.stringify(value)) as T
  } catch {
    return value
  }
}

/** Вставляет родителя над текущими корневыми строками (Swing parseUniDataParents). */
export function wrapTreeTableBackingWithParent(
  parentRow: unknown,
  currentRows: unknown[],
): unknown {
  const parent = cloneJson(parentRow)
  if (!parent || typeof parent !== 'object') return parentRow
  const rec = parent as Record<string, unknown>
  const fields =
    rec.fields && typeof rec.fields === 'object' && !Array.isArray(rec.fields)
      ? { ...(rec.fields as Record<string, unknown>) }
      : {}
  const itemsTable = emptyUniDataTableField()
  itemsTable.value.rows = currentRows
  itemsTable.value.empty = currentRows.length === 0
  fields[IKey.ITEMS] = itemsTable
  rec.fields = fields
  return rec
}
